<template>
    <form :action="action" method="post" @submit="act" ref="form">
        <input type="hidden" name="_token" :value="token">
        <input type="hidden" name="_method" :value="method">
        <a href="#" class="btn btn-sm btn-outline-danger" @click.prevent="act">
            <template v-if="icon">
                <i class="fa" :class="icon" :title="label"></i>
            </template>
            <template v-else>
                {{ label }}
            </template>
        </a>
    </form>
</template>

<script>
export default {
    props: {
        action: {
            type: String,
            required: true
        },
        method: {
            type: String,
            required: true
        },
        token: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    methods: {
        act() {
            if (window.confirm('Sicher?')) {
                this.$refs.form.submit()

                return true;
            }
        }
    },
}
</script>

<style scoped>

</style>
